import { SvgIcon } from '@mui/material';

export default function CheckboxUnchecked() {
  return (
    <SvgIcon width={18} height={18} viewBox="0 0 18 18">
      <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="white" strokeOpacity="0.72" fill="transparent" />
    </SvgIcon>
  );
}
